import { ErrorHandler, } from '@angular/core';
import { ClientErrorCodes } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { Logger, ModalService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { extractErrorMessage } from '@utils/object.utils';
import { TranslatableError } from '@utils/translatable-error';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../services/logger/abstract.logger";
import * as i3 from "../../services/modal.service";
import * as i4 from "@uipath/angular/components/ui-snackbar";
export var ERROR_HANDLER_DEPENDENCIES = [
    TranslateService,
    Logger,
    ModalService,
    UiSnackBarService,
];
var ReloadErrorHandler = /** @class */ (function () {
    function ReloadErrorHandler(_translateService, _logger, _modal, _snack) {
        this._translateService = _translateService;
        this._logger = _logger;
        this._modal = _modal;
        this._snack = _snack;
        this._isHandled = false;
    }
    ReloadErrorHandler.prototype.handleError = function (error) {
        if (this._isHandled) {
            return;
        }
        if (error instanceof TranslatableError) {
            this._handleTranslatableError(error);
            return;
        }
        // handle the unhandled promises :)
        if (error.promise && error.rejection) {
            error = error.rejection;
        }
        // reload the page only when the source isn't
        // coming from a server request (either 4xx, 5xx or timeout — 0)
        var isSourceHttp = error.status && error.status >= 400 || error.status === 0;
        // workaround Chrome bug not showing the error in the correct way
        // this enables again the sourcemaps showing and printing
        // a useful stacktrace
        var stdError = new Error(error.message);
        stdError.name = error.name;
        stdError.stack = error.stack;
        this._logger.error(stdError);
        if (!isSourceHttp ||
            error.isSeed) {
            this._isHandled = true;
            // fallback to English for the error message if translations aren't available
            var translations = this._translateWithFallback({
                global_dialog_error_message: "Sorry! An error occurred and the page will reload.",
            });
            var exceptionMessage = extractErrorMessage(error, '');
            var reloadMessage = "" + translations['global_dialog_error_message'];
            var message = !exceptionMessage ?
                reloadMessage + " (#" + ClientErrorCodes.UnknownUiError + ")" :
                reloadMessage + " (#" + ClientErrorCodes.UnknownUiError + " - " + exceptionMessage + ")";
            this._modal
                .onAlert(message)
                .subscribe(function () { return window.location.reload(); });
        }
        else if (!error.wasShown) {
            var message = extractErrorMessage(error, this._translateService.instant('error_generic') + " (#" + ClientErrorCodes.GenericError + ")");
            this._snack.error(message);
        }
    };
    ReloadErrorHandler.prototype._handleTranslatableError = function (error) {
        this._isHandled = true;
        this._logger.error(error);
        var baseMessage = this._translateWithFallback({
            global_dialog_error_message: "Sorry! An error occurred and the page will reload.",
        }).global_dialog_error_message;
        var detailedMessage = this._translateService.instant(error.translationKey);
        var shownMessage = detailedMessage === error.translationKey ?
            baseMessage + " (#" + error.supportCode + ")" :
            baseMessage + " (#" + error.supportCode + ") - " + detailedMessage;
        this._modal
            .onAlert(shownMessage)
            .subscribe(function () { return window.location.reload(); });
    };
    ReloadErrorHandler.prototype._translateWithFallback = function (translations) {
        var _this = this;
        Object.keys(translations).forEach(function (key) {
            var translation = _this._translateService.instant(key);
            if (translation !== key) {
                translations[key] = translation;
            }
        });
        return translations;
    };
    ReloadErrorHandler.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReloadErrorHandler_Factory() { return new ReloadErrorHandler(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Logger), i0.ɵɵinject(i3.ModalService), i0.ɵɵinject(i4.UiSnackBarService)); }, token: ReloadErrorHandler, providedIn: "root" });
    return ReloadErrorHandler;
}());
export { ReloadErrorHandler };
